module.exports = __webpack_public_path__ + "assets/img/36_790.131fa6bc.jpg";